// ANGULAR
import { Component, OnInit, Inject } from '@angular/core';

// ANGULAR MATERIAL
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WHSafeTranslateService } from '@workheld/workheld-shared-lib';

@Component({
  selector: 'ng-bee-mat-dialog-confirm-entry',
  templateUrl: './mat-dialog-confirm-entry.component.html',
  styleUrls: ['./mat-dialog-confirm-entry.component.scss'],
  standalone: false,
}) 
export class MatDialogConfirmEntryComponent implements OnInit {
  header: string;
  body = null;
  constructor(
    public matDialogRef: MatDialogRef<MatDialogConfirmEntryComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      headerTranslateKey: string;
      headerParams?: Record<string, any>;
      bodyTranslateKey: string;
      bodyParams?: Record<string, any>;
      alertType: '' | 'info' | 'warn';
      alertTranslateKey?: string;
      reverseActions?: boolean;
      submitIcon?: string;
      submitActionTranslateKey?: string;
      cancelActionTranslateKey?: string;
      isCancelHidden: boolean;
      secondarySubmit?: {
        translateKey: string;
        icon?: string;
        color?: 'primary' | 'accent' | 'warn';
        onClick?: () => void;
      }
    },
    private safeTranslateService: WHSafeTranslateService,
  ) {}

  ngOnInit() {
    if (this.data.bodyTranslateKey) {
      this.body = this.safeTranslateService.instant(
        this.data.bodyTranslateKey,
        this.data.bodyParams || undefined,
      );
    }
  }
}
